export default __webpack_public_path__ + "static/media/QI-Using.18431960.jpeg";